import {NEXT_ITEM, PREVIOUS_ITEM} from "../actions/actionTypes";

const navigation = (state = {nextItem: null, previousItem: null}, action) => {
    switch (action.type) {
        case PREVIOUS_ITEM:
            return {...state, previousItem: action.item};
        case NEXT_ITEM:
            return {...state, nextItem: action.item};
        default:
            return state;
    }
};

export default navigation;



// WEBPACK FOOTER //
// ./src/reducers/navigation.js